import { render } from "./SimUserLimitMessage.vue?vue&type=template&id=dda40744&scoped=true"
import script from "./SimUserLimitMessage.vue?vue&type=script&lang=js"
export * from "./SimUserLimitMessage.vue?vue&type=script&lang=js"

import "./SimUserLimitMessage.vue?vue&type=style&index=0&id=dda40744&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dda40744"]])

export default __exports__